import { Validator } from "vee-validate";

export function validators() {
    return {
        phoneValidator(){
            Validator.extend('phone', {
                getMessage: field => 'The phone field be a valid phone.',
                validate: value => /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value)
            });
        },
    }
}

export default validators;